module.exports = __webpack_public_path__ + "img/sensor.51c15ed2.svg";